import {
  NEWSBOARD_POST_AUDIENCE,
  NEWSBOARD_POST_AUDIENCE_TO_ALL_BUILDINGS,
  NEWSBOARD_POST_AUDIENCE_TO_DIGITAL_BOARD,
  NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_DWELLERS,
} from '../Newsboard.constants'

export const RECIPIENT_USERS_ICON =
  NEWSBOARD_POST_AUDIENCE[NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_DWELLERS]?.Icon

export const RECIPIENT_TV_ICON =
  NEWSBOARD_POST_AUDIENCE[NEWSBOARD_POST_AUDIENCE_TO_DIGITAL_BOARD]?.Icon

export const RECIPIENT_ALL_BUILDINGS_ICON =
  NEWSBOARD_POST_AUDIENCE[NEWSBOARD_POST_AUDIENCE_TO_ALL_BUILDINGS]?.Icon
